/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 28e117a928c9fd683efd8274c7a9cbb6 */

import { ConcreteRequest } from "relay-runtime";
export type SendBrokerInterestFieldName = "BROKERAGE_NAME" | "BUSINESS_FLEET" | "COUNTRY" | "EMAIL" | "ESTIMATED_FLEET_GWP" | "ESTIMATED_LEADS_PER_MONTH" | "ESTIMATED_TOTAL_GWP" | "FIRST_NAMES" | "FLEETS_MANAGED" | "LAST_NAME" | "MICRO_MOBILITY_FLEET" | "OTHER_FLEET" | "PHONE_NUMBER" | "PRICING_REQUEST" | "TAXI_FLEET" | "TPM_FLEET" | "WORKS_WITH_FLEETS" | "%future added value";
export type SendBrokerInterestInput = {
    brokerageName: string;
    firstNames: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    fleetsManaged: string;
    worksWithFleets: boolean;
    estimatedTotalGwp: string;
    estimatedFleetGwp: string;
    estimatedLeadsPerMonth: string;
    pricingRequest?: boolean | null;
    taxiFleet?: boolean | null;
    tpmFleet?: boolean | null;
    businessFleet?: boolean | null;
    microMobilityFleet?: boolean | null;
    otherFleet?: boolean | null;
    country?: string | null;
};
export type useSendBrokerInterestMutationVariables = {
    input: SendBrokerInterestInput;
};
export type useSendBrokerInterestMutationResponse = {
    readonly sendBrokerInterest: {
        readonly __typename: "SendBrokerInterestSuccess";
        readonly success: boolean;
    } | {
        readonly __typename: "SendBrokerInterestError";
        readonly fieldErrors: ReadonlyArray<{
            readonly fieldName: SendBrokerInterestFieldName;
            readonly errors: ReadonlyArray<string>;
        }>;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
};
export type useSendBrokerInterestMutation = {
    readonly response: useSendBrokerInterestMutationResponse;
    readonly variables: useSendBrokerInterestMutationVariables;
};



/*
mutation useSendBrokerInterestMutation(
  $input: SendBrokerInterestInput!
) {
  sendBrokerInterest(input: $input) {
    __typename
    ... on SendBrokerInterestSuccess {
      success
    }
    ... on SendBrokerInterestError {
      fieldErrors {
        fieldName
        errors
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SendBrokerInterestInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "sendBrokerInterest",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "type": "SendBrokerInterestSuccess",
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "success",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "InlineFragment",
        "type": "SendBrokerInterestError",
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "fieldErrors",
            "storageKey": null,
            "args": null,
            "concreteType": "SendBrokerInterestInvalidField",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fieldName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "errors",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "useSendBrokerInterestMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "useSendBrokerInterestMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "useSendBrokerInterestMutation",
    "id": null,
    "text": "mutation useSendBrokerInterestMutation(\n  $input: SendBrokerInterestInput!\n) {\n  sendBrokerInterest(input: $input) {\n    __typename\n    ... on SendBrokerInterestSuccess {\n      success\n    }\n    ... on SendBrokerInterestError {\n      fieldErrors {\n        fieldName\n        errors\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'f39f74ff3d7da514edc9f416628dc53d';
export default node;
